import * as React from "react";
import { ITranslationProps, translateComponent } from "../../helpers/translation";

function NotFound(p: ITranslationProps) {
    return (
        <div className="alert alert-warning">
            {p.t("Nav.NotFoundMessage")}
        </div>
    );
}

export default translateComponent(NotFound);



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.tsx